import '../../sass/plugins/recently_sold.scss';
import { LARGE_SCREEN, EXTRA_LARGE_SCREEN } from '../consts';

$(() => {
  const slider = $('.recently-sold-slider');
  const nextArrow = $('.secondary-navigator#recently-sold-next-arrow');
  const prevArrow = $('.secondary-navigator#recently-sold-prev-arrow');

  slider.slick({
    infinite: true,
    variableWidth: false,
    mobileFirst: true,
    slidesToShow: 1,
    nextArrow,
    prevArrow,
    responsive: [
      {
        breakpoint: LARGE_SCREEN,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: EXTRA_LARGE_SCREEN,
        settings: {
          slidesToShow: 3,
        },
      },
    ],
  });
});
